import { Pipe, PipeTransform } from '@angular/core';
import {Practice} from '../models/Practice';
import {Role} from '../enums/role';
import {practiceHasFeature} from '../helpers/practice-has-feature';
import {PracticeFeature} from '../enums/practice-feature';

@Pipe({name: 'canViewTemplates'})
export class CanViewTemplatesPipe implements PipeTransform {
  transform(practice: Practice, userRole: Role): boolean {
    return userRole === Role.SYSTEM_ADMIN || userRole === Role.COMPANY_ADMIN || userRole === Role.SUPER_ADMIN;
  }
}
